//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss'
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const workOut = useStore((state) => state.workOut);
  const setWorkOut = useStore((state) => state.setWorkOut);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.workOut.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={workOut}
          onChange={(value) => {
            setWorkOut(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'work-out',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Very active'}>
            <span>💪</span> {t('onboarding.workOut.options.veryActive')}
          </Option>
          <Option value={'Active'}>
            <span>👍</span> {t('onboarding.workOut.options.active')}
          </Option>
          <Option value={'Lightly active'}>
            <span>🤨</span> {t('onboarding.workOut.options.lightlyActive')}
          </Option>
          <Option value={'Low'}>
            <span>🙅</span> {t('onboarding.workOut.options.low')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
